<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Notes</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">Notes</h3>
            <base-button size="sm" type="default">New</base-button>
          </div>
        </b-card-header>
        <b-table small responsive :items="notes"></b-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [ errorsMixin ],
  components: {
    RouteBreadCrumb
  },
  data() {
    return {
      notes: [],
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    })
  },
  methods: {
    
  },
  created() {
    
  }
}
</script>